import React from 'react';
import { Field } from 'formik';

import styles from './fundHoldingsFormStyles';

import FundHoldingsAutocomplete from './FundHoldingsAutocomplete/fundHoldingsAutocomplete';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';
import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

const { employerProfileHoldingTimeframes } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const assetClassOptions = ['Equity', 'Corporate Debt', 'Preferred'];
const assetClassLabel = assetClass => {
  switch (assetClass) {
    case 'Corporate Debt':
      return 'CUSIP';
    case 'Preferred':
      return 'CUSIP';
    default:
      return 'Symbol';
  }
};

const FundHoldingsForm = ({ setFieldValue }) => {
  const renderFundHolding = (holdingPath, holding) => (
    <div>
      <div className={styles.holdingRow}>
        <div className={styles.holdingColumn}>
          <Field
            component={InputField}
            name={holdingPath + '.assetClass'}
            type="select"
            options={assetClassOptions}
            label="Asset Class"
          />
        </div>
      </div>
      <div className={styles.holdingRow}>
        <div className={styles.holdingColumn}>
          <FundHoldingsAutocomplete
            name={holdingPath}
            setFieldValue={setFieldValue}
            assetClass={holding.assetClass}
            assetClassLabel={assetClassLabel(holding.assetClass)}
          />
        </div>
      </div>
      <div className={styles.holdingRow}>
        <div className={styles.holdingColumn}>
          <Field
            component={InputField}
            name={holdingPath + '.percentOfPortfolio'}
            label="Portfolio Allocation %"
          />
        </div>
        <div className={styles.holdingColumn}>
          <Field
            component={InputField}
            name={holdingPath + '.averageCost'}
            label="Weighted Avg. Cost Basis"
          />
        </div>
      </div>
      <div className={styles.holdingRow}>
        <div className={styles.holdingColumn}>
          <Field component={InputField} name={holdingPath + '.priceTarget'} label="Target Price" />
        </div>
        <div className={styles.holdingColumn}>
          <Field
            component={InputField}
            name={holdingPath + '.timeframe'}
            type="select"
            label="Timeframe"
            options={employerProfileHoldingTimeframes}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <AddRemoveForm
        title="Holdings"
        attr="fundProfile.holdings"
        renderItem={renderFundHolding}
        itemName="Holding"
        blankItem={{
          assetClass: 'Equity',
          primarySymbol: '',
          percentOfPortfolio: '',
          averageCost: '',
          priceTarget: '',
          timeframe: ''
        }}
      />
      <DocumentsForm
        title="Supporting Documents"
        attr="fundProfile.holdingsDocuments"
        withDescription
        withMargin
      />
    </div>
  );
};

export default FundHoldingsForm;
